import type { IconSvgObject } from './types';

const SquareDashedTopSolidIcon: IconSvgObject = [
  ["path", { d: "M19.5 21.5C20.6046 21.5 21.5 20.6046 21.5 19.5M2.50001 19.5C2.50001 20.6046 3.39544 21.5 4.50001 21.5M14 21.5H15.5M8.50001 21.5H10M2.5 4.5C2.5 3.39543 3.39543 2.5 4.5 2.5L19.5 2.5C20.6046 2.5 21.5 3.39543 21.5 4.5M2.5 14L2.5 15.5M2.5 8.5L2.5 10M21.5 10V8.5M21.5 15.5V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default SquareDashedTopSolidIcon;
